/* eslint-disable react/jsx-props-no-spreading */
import React, { useRef, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalFooter,
  Typography,
} from '@one-thd/sui-atomic-components';
import _isNaN from 'lodash/isNaN';
import {
  addRoomMeasure,
  saveEdit,
} from '../../actions';
import { useIsMobile } from '../ProjectLocation/helpers';
import { containsSpecialChars } from '../../utils/inputValidation';
import InputMeasure from '../inputMeasure';
import InputRoomName from '../InputRoomName';
import useFieldVerification from './useFieldVerification';
import {
  InputWrapper,
  InputWrapperNumber,
  FormContainer,
  RoomContainer,
  CustomBody,
  MobileForm,
  Form,
} from './styles';
import { AddRoomPropTypes, defaultAddRoomPropTypes } from './_propTypes';

function AddRoom(props) {
  const {
    roomName,
    roomNamePlaceholder,
    roomLength,
    roomLengthPlaceholder,
    roomWidth,
    roomWidthPlaceholder,
    isEdit,
    updatedMeasure,
    onChoiceSelected,
    option,
    showModal,
    handleClose,
  } = props;
  const {
    roomError,
    roomErrorText,
    lengthError,
    lengthErrorText,
    widthError,
    widthErrorText,
    styleHelper,
    validField,
    resetFields,
  } = useFieldVerification();
  const dispatch = useDispatch();
  const selectedChoiceId = option && option.choices[0];
  const measureRef = useRef({});
  const roomRef = useRef({});
  const isMobile = useIsMobile();

  const validValue = () => {
    const isValid = (val) => val !== '' && !_isNaN(val) && val >= 1 && val < 100;
    const first = roomRef.current.room_name;
    const second = measureRef.current.room_length;
    const third = measureRef.current.room_width;
    const firstCondition = first.value !== '' && !containsSpecialChars(first.value);
    return (firstCondition && isValid(second.value) && isValid(third.value));
  };

  const addRoomHandle = (event) => {
    const first = roomRef.current.room_name;
    const second = measureRef.current.room_length;
    const third = measureRef.current.room_width;
    const allField = [first, second, third];
    const currentMeasure = {
      room: first.value,
      length: second.value,
      width: third.value,
    };
    if (validValue()) {
      dispatch(addRoomMeasure(currentMeasure));
      onChoiceSelected(option.id, selectedChoiceId, 'roommeasurements');
      resetFields(first, second, third);
      handleClose();
    } else {
      allField.map((field) => validField(field, first, second, third));
    }
    event.target.blur();
  };

  const saveChangesHandle = (event) => {
    let inputValues = {};
    const first = document.getElementById('room');
    const second = document.getElementById('length');
    const third = document.getElementById('width');
    const allField = [first, second, third];
    // further we can also make ids coming from props
    const rooms = first.value;
    const lengths = second.value;
    const widths = third.value;
    inputValues = {
      ids: updatedMeasure.id,
      rooms,
      lengths,
      widths,
    };
    if (validValue()) {
      dispatch(saveEdit(inputValues));
      resetFields(first, second, third);
    } else {
      allField.map((field) => validField(field, first, second, third));
    }
    event.target.blur();
  };

  const handleCloseModal = () => {
    const first = document.getElementById('room');
    const second = document.getElementById('length');
    const third = document.getElementById('width');
    resetFields(first, second, third);
    handleClose();
  };

  return (
    <>
      <FormContainer id="roomMeasures" data-testid="room-dimensions">
        <RoomContainer>
          <Modal size="md" open={showModal} onClose={handleClose}>
            <ModalHeader onClose={handleClose}>
              <Typography variant="h4" weight="bold" style={{ marginBottom: '1.6rem' }}>
                {!isEdit ? 'Add a Room' : 'Edit Room'}
              </Typography>
            </ModalHeader>
            <CustomBody>
              <Form>
                <InputWrapper>
                  <InputRoomName
                    id="room"
                    forwardedRef={roomRef}
                    inputName="room_name"
                    placeholder={roomNamePlaceholder}
                    showError={roomError}
                    errorText={roomErrorText}
                    label={roomName}
                    value={isEdit ? updatedMeasure?.room : undefined}
                  />
                </InputWrapper>
                <MobileForm>
                  <InputWrapperNumber>
                    <InputMeasure
                      id="length"
                      forwardedRef={measureRef}
                      inputName="room_length"
                      placeholder={roomLengthPlaceholder}
                      showError={lengthError}
                      errorText={lengthErrorText}
                      label={roomLength}
                      value={isEdit ? updatedMeasure?.length : undefined}
                    />
                  </InputWrapperNumber>
                  <InputWrapperNumber>
                    <InputMeasure
                      id="width"
                      forwardedRef={measureRef}
                      inputName="room_width"
                      placeholder={roomWidthPlaceholder}
                      showError={widthError}
                      errorText={widthErrorText}
                      label={roomWidth}
                      value={isEdit ? updatedMeasure?.width : undefined}
                    />
                  </InputWrapperNumber>
                </MobileForm>

              </Form>
            </CustomBody>
            <ModalFooter position="end">
              <ButtonGroup
                orientation={isMobile ? 'vertical' : 'horizontal'}
                variant={isMobile ? 'primary' : 'secondary'}
              >
                <Button variant="secondary" style={{ display: isMobile && 'none' }} onClick={handleCloseModal}>Cancel
                </Button>
                {!isEdit ?
                  (<Button variant="primary" onClick={(event) => addRoomHandle(event)}>Add Room</Button>) :
                  (<Button variant="primary" onClick={(event) => saveChangesHandle(event)}>Update Room</Button>)}

                <Button variant="secondary" style={{ display: !isMobile && 'none' }} onClick={handleCloseModal}>Cancel
                </Button>
              </ButtonGroup>
            </ModalFooter>
          </Modal>
        </RoomContainer>
      </FormContainer>
    </>
  );
}

AddRoom.propTypes = AddRoomPropTypes;

AddRoom.defaultProps = defaultAddRoomPropTypes;
export default AddRoom;
